import cloneDeep from 'lodash/cloneDeep';
import Chance from 'chance';

const chance = new Chance();

export function copyFluid(caseConf, existingFluid) {
  // Returns updates with existing and new customFluids and fluids
  const updates = {};
  const customFluidKey = chance.guid();
  const newCustomFluid = {
    key: customFluidKey,
    label: {
      en: existingFluid.label.en + ' (copy)'
    },
    abbreviation: {
      en: existingFluid.abbreviation.en + ' (copy)'
    },
    availableBagVolumes: cloneDeep(existingFluid.availableBagVolumes),
  };

  updates.customFluids = cloneDeep(caseConf.customFluids || []);
  updates.customFluids.push(newCustomFluid);

  const caseFluid = (caseConf.fluids || []).find(cf => cf.key === existingFluid.key);
  if (caseFluid) {
    const newCaseFluid = {
      ...caseFluid,
      key: customFluidKey,
      id: chance.guid(),
    }
    updates.fluids = cloneDeep(caseConf.fluids || []);
    updates.fluids.push(newCaseFluid);
  }
  return updates;
}
